import { NgClass } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'ui-dropzone',
  imports: [NgIcon, NgClass],
  templateUrl: './dropzone.html',
})
export class Dropzone {
  accept = input<string | null>(null);

  dropFiles = output<FileList>();

  protected dropEnabled = signal(false);

  protected onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dropEnabled.set(this.isAccepted(event));
  }

  protected onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dropEnabled.set(false);
  }

  protected onDrop(event: DragEvent) {
    event.preventDefault();
    if (!this.dropEnabled()) {
      return;
    }

    this.dropEnabled.set(false);

    if (!this.isAccepted(event)) {
      return;
    }

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.dropFiles.emit(files);
    }
  }

  private isAccepted(event: DragEvent) {
    const acceptedMimeTypes =
      this.accept()
        ?.split(',')
        .map((type) => type.trim()) ?? [];

    if (acceptedMimeTypes.length === 0) {
      return true;
    }

    const dataTransferItems = Array.from(event.dataTransfer?.items ?? []);
    const files = Array.from(event.dataTransfer?.files ?? []);
    const dragFileTypes = (dataTransferItems.length > 0 ? dataTransferItems : files).map(
      (item) => item.type,
    );

    return acceptedMimeTypes.some((type) => dragFileTypes.includes(type));
  }
}
